import React from "react";

const AirTicketing = () => {
  return (
    <div className="card" id="air-ticketing">
      <h1 className="title">
        Benefits of taking{" "}
        <span
          className=""
          style={{
            color: "#13589D",
            textDecoration: "underline",
          }}>
          Air Ticket
        </span>{" "}
        through Globaldreamz
      </h1>
      <ul className="list-style-1 mb--20">
        <li>
          <i className="icon-checkbox-circle-fill-solid"></i>Exclusive Deals &
          Offers{" "}
        </li>
        <li>
          <i className="icon-checkbox-circle-fill-solid"></i>Lowest Fare{" "}
        </li>
        <li>
          <i className="icon-checkbox-circle-fill-solid"></i>Zero Convenience
          Fees{" "}
        </li>
      </ul>
    </div>
  );
};

export default AirTicketing;
